import React from 'react';

const SchoolItemContext = React.createContext({});

export default SchoolItemContext;
